import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { WebApiCalls } from '../../../webApiCalls/WebApiCalls';
import DataTable from 'react-data-table-component';
import { useAuth } from '../../../hooks/useAuth';
import moment from 'moment';
import { PDFDownloadLink } from '@react-pdf/renderer';
import RewardsPDF from './RewardsPDF';

const customStyles = {
    rows: {
        style: {
            // minHeight: '72px' // override the row height
            textAling: 'center'
        }
    },
    headCells: {
        style: {
            paddingLeft: '8px', // override the cell padding for head cells
            paddingRight: '8px',
            backgroundColor: '#13aa61',
            color: 'white',
            '&:hover': {
                cursor: 'pointer'
            }
        }
    }
};
const VendorDetail = () => {
    const [vendorDetail, setVendorDetail] = useState();
    const [routeDetail, setRouteDetail] = useState();
    const [rewards, setRewards] = useState();
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const { getToken } = useAuth();
    const { state } = useLocation();

    useEffect(() => {
        if (state?.vendor_id) {
            console.log(state);
            getVendorDetail(state?.vendor_id);
            getVendorRewards(pageSize, 1, state?.vendor_id);
        }
    }, []);

    const getVendorDetail = async (id = '') => {
        const token = getToken();
        if (token && id) {
            new WebApiCalls()
                .getSingleVendor(token, id)
                .then((res) => {
                    if (res?.code === 200) {
                        const { data } = res;
                        setVendorDetail(data);
                    }
                })
                .catch((err) => {});
        }
    };
    const getRouteDetail = async (id = '') => {
        const token = getToken();
        if (token && id) {
            new WebApiCalls()
                .getSingleRoute(token, id)
                .then((res) => {
                    if (res?.code == 200) {
                        const { data } = res;
                        setRouteDetail(data);
                    }
                })
                .catch((err) => {});
        }
    };
    const handlePerRowsChange = async (pageSize, pageNo) => {
        console.log('here is the paginattion newPerPage', pageSize, pageNo);
        getVendorRewards(pageSize, pageNo, state?.vendor_id);
        setPageSize(pageSize);
        // setLoading(false);
    };
    const handlePageChange = (pageNo) => {
        // fetchUsers(page);
        console.log('here is the paginattion', pageNo);
        getVendorRewards(pageSize, pageNo, state?.vendor_id);
    };
    //pageSize = 10, pageNo = 0, _transitType, _status, _search
    const getVendorRewards = async (pageSize = 10, pageNo = 0, id = '') => {
        const token = getToken();
        if (id && token) {
            new WebApiCalls()
                .getAllRewards(token, pageSize, pageNo, '', '', '', id)
                .then((res) => {
                    if (res?.code === 200) {
                        setRewards(res?.data?.rewards);
                        setTotalRecords(res?.data?.totalCount);
                        console.log('Res here:  ', res);
                    }
                })
                .catch((err) => {
                    console.log('Error in Agency details:   ', err);
                });
        }
    };
    const updateSingle = () => {};

    const columns = [
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Name</span>
                </h6>
            ),
            selector: (row) => row.name,
            center: true
            // sortable: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold ">Allowed Redeems</span>
                </h6>
            ),
            selector: (row) => row.noOfAllowRedeems,
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Redeem Count</span>
                </h6>
            ),
            selector: (row) => row?.redeemedCount,
            // sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Required Points</span>
                </h6>
            ),
            selector: (row) => row?.requiredPoints,
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Status</span>
                </h6>
            ),
            selector: (row) => (
                <select
                    disabled={true}
                    value={row?.status}
                    onChange={(e) => {
                        e.preventDefault();
                        updateSingle(row?._id, e.target.value);
                    }}
                    className={row?.status === 'inactive' ? 'status-selector-inactive' : 'status-selector'}
                    aria-label="Default select example"
                >
                    <option value={'active'}>Active</option>
                    <option value={'inactive'}>Inactive</option>
                </select>
            ),
            center: true
            // sortable: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Validity</span>
                </h6>
            ),
            selector: (row) => moment(row?.validity).format('YYYY-MM-DD'),
            center: true
            // sortable: true
        }
        // {
        //     name: (
        //         <h6 className="text-capitalize mt-2 text-center">
        //             <span className="fw-bold">Action</span>
        //         </h6>
        //     ),
        //     selector: (row) => (
        //         <div className="d-flex">
        //             <div className="view-detail">
        //                 <img
        //                     width={15}
        //                     className="me-3"
        //                     src={viewIcon}
        //                     alt=""
        //                     onClick={() => {
        //                         navigate("/rewards/reward-detail", { state: { reward_id: row?._id, reward_detail: row } })
        //                     }}
        //                 />
        //             </div>
        //             <div className="edit-detail">
        //                 <img
        //                     width={15}
        //                     className="me-3"
        //                     src={editIcon}
        //                     alt=""
        //                     onClick={() => {
        //                         // setSelectedItem(row);
        //                         // setShowEditModal(true);
        //                     }}
        //                 />
        //             </div>
        //             <div className="del-detail">
        //                 <img
        //                     width={15}
        //                     src={delIcon}
        //                     alt=""
        //                     onClick={() => {
        //                     }}
        //                 />
        //             </div>
        //         </div>
        //     ),
        //     center: true
        //     // sortable: true
        // }
    ];
    const [allRewards, setAllRewards] = useState([]);

    const getAllVendorRewards = async () => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                .getAllRewards(token, '', '', '', '', '', '', true)
                .then((res) => {
                    if (res?.code === 200) {
                        setAllRewards(res?.data?.rewards);

                        console.log('Res here:  ', res);
                    }
                })
                .catch((err) => {
                    console.log('Error in Rewards details:   ', err);
                });
        }
    };

    useEffect(() => {
        getAllVendorRewards();
    }, []);

    return (
        <>
            <Row className="justify-content-end align-items-center">
                <Col sm={6} md={6} className="text-center ">
                    <div className="d-flex justify-content-end gap-2">
                        {vendorDetail?.logo && allRewards?.length ? (
                            <PDFDownloadLink document={<RewardsPDF vendorDetail={vendorDetail} rewards={allRewards} />} fileName="rewards.pdf">
                                <Button className="export-file justify-content-center w-140 align-items-center" style={{ background: '#198754' }}>
                                    Export PDF
                                </Button>
                            </PDFDownloadLink>
                        ) : (
                            ''
                        )}

                        <Link to="/vendors">
                            <Button className="theme-cancel-btn px-5 py-2">Close</Button>
                        </Link>
                    </div>
                </Col>
            </Row>
            {/* <Row>
                <Col sm={4}>
                <div className="detail-heading ms-5">Vendor Details</div>
                </Col>
            </Row> */}

            <Row className="d-flex justify-content-center">
                <Col xs={12} sm={12} md={11} lg={11} className="p-4 m-3 ">
                    <Row>
                        <Col sm={6} md={3} className="mb-1 text-center">
                            <div className="detail-image-container">
                                <img src={vendorDetail?.logo} alt="" />
                            </div>
                        </Col>
                        <Col sm={6} md={9} className="mb-1">
                            <Row>
                                <Col sm={6} md={4} className="mb-4">
                                    <div className="detail-small-heading">Name</div>
                                    <div className="detail-value">{vendorDetail?.name}</div>
                                </Col>

                                <Col sm={6} md={4} className="mb-4">
                                    <div className="detail-small-headingg">Location</div>
                                    <div className="detail-value">{vendorDetail?.location}</div>
                                </Col>
                                <Col sm={6} md={4} className="mb-4">
                                    <div className="detail-small-headingg">Phone Number</div>
                                    <div className="detail-value">{vendorDetail?.phone_no}</div>
                                </Col>

                                <Col sm={6} md={4} className="mb-4">
                                    <div className="detail-small-headingg">Route</div>
                                    <div className="detail-value">{vendorDetail?.route?.name}</div>
                                </Col>

                                <Col sm={6} md={4} className="mb-4">
                                    <div className="detail-small-heading text-capitalize">Vendor Type</div>
                                    <div className="detail-value">{vendorDetail?.vendor_type}</div>
                                </Col>
                                <Col sm={6} md={4} className="mb-4">
                                    <div className="detail-small-headingg">Website</div>
                                    <div className="detail-value">{vendorDetail?.vendor_website}</div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <hr className="mt-3" />
                            <Row className="mt-4">
                                <Col md={4}>
                                    <div className="detail-value mb-4">Rewards Listing</div>
                                </Col>
                            </Row>
                            <DataTable
                                columns={columns}
                                data={rewards}
                                // selectableRows
                                responsive
                                pagination
                                paginationServer
                                paginationTotalRows={totalRecords}
                                onChangeRowsPerPage={handlePerRowsChange}
                                onChangePage={handlePageChange}
                                // responsive
                                // direction="auto"
                                // fixedHeaderScrollHeight="300px"
                                // subHeaderAlign="right"
                                // subHeaderWrap
                                customStyles={customStyles}
                                // onSelectedRowsChange={handleRowSelected}
                                // clearSelectedRows={toggleCleared}
                                // defaultSortFieldId={1}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
};

export default VendorDetail;
